/** 注册奖励：积分阈值等（历史 claimed 窗已下线；guest 窗仍用资源表） */
export const REGISTER_REWARD_POINTS_THRESHOLD = 188;

/** 首次充值赠送积分（与 earn-dscoin「首次登录+首次充值」档一致） */
export const REGISTER_REWARD_FIRST_DEPOSIT_POINTS = 5;

/** 该档合计上限（登录 + 充值） */
export const REGISTER_REWARD_SECTION_MAX_POINTS =
  REGISTER_REWARD_POINTS_THRESHOLD + REGISTER_REWARD_FIRST_DEPOSIT_POINTS;

/** 展示用：约 100 DScoin ≈ $1 */
export const REGISTER_REWARD_USD_APPROX = REGISTER_REWARD_POINTS_THRESHOLD / 100;

/** 未登录引导：历史 session key（曾存 mini；现仅用于清理残留） */
export const REGISTER_REWARD_GUEST_VIEW_SESSION_KEY = 'ds-register-reward-guest-view';

/** 未登录引导：「今日不再提示」本地缓存（值为 yyyy-MM-dd，次日 0 点失效） */
export const REGISTER_REWARD_GUEST_SNOOZE_DATE_KEY = 'ds-register-reward-guest-snooze-date';

/** 注册后展示窗口：createTime 距现在超过此时长不再弹、也不再查积分 */
export const REGISTER_REWARD_MAX_AGE_MS = 2 * 60 * 1000;

export const REGISTER_REWARD_GRADIENT_START = '#224bfb';
export const REGISTER_REWARD_GRADIENT_END = '#7b48ff';

export const REGISTER_REWARD_GRADIENT = `linear-gradient(90deg, ${REGISTER_REWARD_GRADIENT_START} 0%, ${REGISTER_REWARD_GRADIENT_END} 100%)`;

/** 静态资源根路径（部署环境走同源 /resource；本地与 SSR 回退 deepsage.app） */
export function resolveRegisterRewardResourceBase() {
  const remoteBase = 'https://deepsage.app/resource';
  if (typeof window === 'undefined') return remoteBase;

  const { hostname, origin } = window.location;
  const isLocalHost =
    hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.local');
  if (isLocalHost) return remoteBase;

  return `${origin}/resource`;
}

export function getRegisterRewardAssets() {
  return {
    /** 未登录引导 / 福利盘大窗：同源 public */
    guestChest: '/resource/register-reward/guest-chest.png',
    guestBadge: '/resource/register-reward/guest-badge.png',
    guestCheck: '/resource/register-reward/guest-check.svg',
    guestShield: '/resource/register-reward/guest-shield.svg',
    guestCorrect: '/resource/register-reward/guest-correct.svg',
  };
}
